import { CommonModule, formatDate } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MaterialModule } from 'src/app/material.module';
// import { MaterialModule } from 'src/app/material.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { HeaderStyleOneComponent } from 'src/app/components/common/header-style-one/header-style-one.component';
import { Apiservice } from 'src/app/services/apiservice';
import { TrimLeadingSpace } from 'src/app/directives/trim-leading-space';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
@Component({
  selector: 'app-registrationform',
  imports: [MatTableModule, MatPaginatorModule, MatFormFieldModule, MatInputModule, MatSortModule, CommonModule, FormsModule, MaterialModule, NgSelectModule, ReactiveFormsModule, HeaderStyleOneComponent, TrimLeadingSpace],
  templateUrl: './registrationform.html',
  styleUrl: './registrationform.scss'
})
export class Registrationform {
  // district_id: any;
  // ulb_id: any;
  // selectSlf: any;
  districtData: any = [];
  ulbData: any = [];
  slfData: any = [];
  shgGropsReport: any = [];
  shgmembersReport: any = [];
  registrationform: FormGroup
  photoPreview: any = null;
  showloader: any;
  relationships: any = [
    { id: 1, name: "Father" },
    { id: 2, name: "Mother" },
    { id: 3, name: "Husband" },
    { id: 4, name: "Wife" },
    { id: 5, name: "Son" },
    { id: 6, name: "Daughter" },
    { id: 7, name: "Brother" },
    { id: 8, name: "Sister" },
    { id: 9, name: "Uncle" },
    { id: 10, name: "Aunt" },
    { id: 11, name: "Cousin" },
    { id: 12, name: "Grandfather" },
    { id: 13, name: "Grandmother" },
    { id: 14, name: "Guardian" },
    { id: 15, name: "Other" }
  ];
  qualifications: any = [
    { value: '10th', label: '10th Standard' },
    { value: '12th', label: '12th Standard' },
    { value: 'Diploma', label: 'Diploma' },
    { value: 'Degree', label: 'Degree' },
    { value: 'B.Tech', label: 'B.Tech' },
    { value: 'M.Tech', label: 'M.Tech' },
    { value: 'MBA', label: 'MBA' },
    { value: 'MCA', label: 'MCA' },
    { value: 'PhD', label: 'PhD' },
    { value: 'B.Pharmacy', label: 'B.Pharmacy' },
    { value: 'D.Pharmacy', label: 'D.Pharmacy' },
    { value: 'M.Pharmacy', label: 'M.Pharmacy' },
    { value: 'ITI', label: 'ITI' },
    { value: 'MSc', label: 'MSc' },
    { value: 'Bsc Nursing', label: 'Bsc Nursing' },
    { value: 'BBA', label: 'BBA' },
    { value: 'Others', label: 'Others' }


  ];
  submittedregist: boolean;
  currentdate: any = new Date().toISOString().slice(0, 10)
  @ViewChild('formContainer') formContainer: ElementRef;
  showOtp: boolean = false;
  otprequestData: any;
  memberNo: any;
  radiobtn: boolean = true;
  constructor(private fb: FormBuilder, private api: Apiservice, private router: Router) { }
  ngOnInit(): void {

    this.registrationform = this.fb.group({
      are_you_shg: ['Yes'],
      district_id: ['', Validators.required],
      ulb_id: ['', Validators.required],
      slf_id: ['', Validators.required],
      shg_id: ['', Validators.required],
      member_id: ['', Validators.required],
      relation_with_shg: [''],
      // 1. Personal Information
      full_name: [''],
      father_or_husband_name: ['', Validators.required],
      date_of_birth: ['', Validators.required],
      gender: ['', Validators.required],
      contact_number: ['', [Validators.required,Validators.pattern(/^[6-9][0-9]{9}$/)]],
      email: ['', [Validators.required, Validators.email]],
      aadhaar_number: ['', [Validators.required, Validators.pattern('^\\d{12}$')]],
      address: ['', Validators.required],

      // 2. Educational Qualification
      highest_qualification: ['', Validators.required],
      year_of_passing: ['', Validators.required],
      university_or_board: ['', Validators.required],

      // 3. Employment Details
      currently_employed: ['', Validators.required],
      work_company_name: [''],
      designation: [''],
      work_experience: [''],
      otp: ['12345'],
      shg_otp: ['12345']
    });
    this.registrationform.get('are_you_shg')?.valueChanges.subscribe(value => {
      const relationControl = this.registrationform.get('relation_with_shg');

      if (value == 'Yes') {
        this.radiobtn = true;
        // relationControl?.setValidators(Validators.required);
        this.registrationform.get('shg_id')?.reset();
        this.registrationform.get('member_id')?.reset();
        this.registrationform.get('relation_with_shg').reset();
      } else {
        // relationControl?.clearValidators();
        this.registrationform.get('full_name')?.reset();
        this.registrationform.get('date_of_birth')?.reset();
        this.registrationform.get('contact_number')?.reset();
        this.registrationform.get('aadhaar_number')?.reset();
        this.registrationform.get('address')?.reset();
        this.radiobtn = false;
      }

      // relationControl?.updateValueAndValidity();
    });
    this.registrationform.get('currently_employed')?.valueChanges.subscribe(value => {
      // const isYes = value === 'Yes';
      // const controls = [
      //   'work_company_name',
      //   'designation',
      //   'work_experience'
      // ];
      // controls.forEach(controlName => {
      //   const control = this.registrationform.get(controlName);
      //   if (control) {
      //     if (isYes) {
      //       control.setValidators([Validators.required]);
      //     } else {
      //       control.clearValidators();
      //     }
      //     control.updateValueAndValidity();
      //   }
      // });
    });
    // this.getProfileData();
    this.getgetDistrictData();

  }
  getProfileData() {
    this.api.getUserprofileData().subscribe((res: any) => {
      console.log(res);
      this.showloader = false;
      if (res.status == 200) {
        let user = res.data[0];
        this.registrationform.patchValue({
          contact_number: user.phone_number
        });
      }
    }, err => {
      this.showloader = false;
    })
  }
  getgetDistrictData() {
    this.showloader = true;
    this.api.getDistrictData().subscribe((res: any) => {
      this.showloader = false;
      if (res.status == 200) {
        this.districtData = res.data;
        console.log(this.districtData);

      }
    }, err => {
      this.showloader = false;
    });
  };
  getUlbData(event) {
    this.showloader = true;
    console.log(event);
    this.ulbData = [];
    this.registrationform.get('ulb_id')?.reset();
    this.registrationform.get('slf_id')?.reset();
    this.registrationform.get('shg_id')?.reset();
    this.registrationform.get('member_id')?.reset();
    // this.ulb_id = '';
    let obj = {
      district_id: event
    };
    this.api.getUlbData(obj).subscribe((res: any) => {
      this.showloader = false;
      if (res.status == 200) {
        this.ulbData = res.data;
        console.log(this.ulbData);
      }
    }, err => {
      this.showloader = false;
    });
  }

  getSLFdetails(event) {
    console.log(event);
    this.showloader = true;
    let obj = {
      ulb_id: event,
    }
    console.log(obj)
    this.slfData = [];
    this.registrationform.get('slf_id')?.reset();
    this.registrationform.get('shg_id')?.reset();
    this.registrationform.get('member_id')?.reset();
    this.api.getulbbasedSlfData(obj).subscribe((res: any) => {
      this.showloader = false;
      if (res.status == 200) {
        this.slfData = res.data;
        console.log(this.slfData);
      };

    }, err => {
      this.showloader = false;
    })
  };
  getShgGropsReport(event) {
    console.log(event);
    this.showloader = true;
    let obj = {
      slf_id: event.slf_id ?? event
    };
    this.shgGropsReport = [];
    this.registrationform.get('shg_id')?.reset();
    this.registrationform.get('member_id')?.reset();
    this.api.getShgGropsReport(obj).subscribe((res: any) => {
      if (res.status == 200) {
        this.shgGropsReport = res.data;
        console.log(this.shgGropsReport);
        this.showloader = false;
      }
    }, err => {
      this.showloader = false;
    });
  }
  getShgmembersReport(event) {
    console.log(event);
    this.showloader = true;
    // this.vendorDetails.group_id = event.shg_group_id;
    // this.vendorDetails.group_name = event.shg_group_name;
    let obj = {
      shg_group_id: event
    }
    console.log(obj)
    this.shgmembersReport = [];
    this.registrationform.get('member_id')?.reset();
    this.api.getShgbasedmembersData(obj).subscribe((res: any) => {
      console.log(res);

      this.showloader = false;
      // if (res.status == 200) {
      // console.log(res);
      this.shgmembersReport = res.data;
      console.log(this.shgmembersReport);

      // }
    }, err => {
      this.showloader = false;
    })

  }
  getShgmemberdetails(event) {
    console.log(event);
    let are_you_shg = this.registrationform.get('are_you_shg')?.value;
    if (are_you_shg == 'Yes') {
      this.radiobtn = true;
      let memberdata = this.shgmembersReport.filter(a => a.member_id == event);
      console.log(memberdata);

      let newdate;
      const dob = memberdata[0].date_of_birth;

      if (dob) {
        const [day, month, year] = dob.split('-');
        newdate = new Date(+year, +month - 1, +day);
      } else {
        newdate = '';
      }
      console.log(newdate);
      this.registrationform.value.shg_ph_no = memberdata[0].mobile_number;
      this.registrationform.value.shg_member_name = memberdata[0].member_name;
      this.registrationform.patchValue({
        full_name: memberdata[0].member_name,
        date_of_birth: newdate ? formatDate(newdate, 'yyyy-MM-dd', 'en') : '',
        gender: memberdata[0].gender,
        contact_number: memberdata[0].mobile_number,
        aadhaar_number: memberdata[0].citizen_id,
        address: memberdata[0].address
      })
      const control = this.registrationform.get('full_name');
      control.updateValueAndValidity();
    } else {
      this.radiobtn = false;
    };
  }



  // getadminSlfReport(event) {

  // }
  // getShgTotalReport(event) {

  // }
  get regist() { return this.registrationform.controls; }
  submitRegistrationDetails() {
    // console.log(this.registrationform.value);
    const control = this.registrationform.get('full_name');
    control.updateValueAndValidity();
    this.submittedregist = true;
    if (this.registrationform.invalid) {
      console.log('hiii', this.registrationform.controls)
      setTimeout(() => {
        const firstInvalid = this.formContainer.nativeElement.querySelector('.ng-invalid');
        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInvalid.focus();
        }
      }, 0);
      return;
    } else {
      if (this.photoPreview != null) {
        console.log(this.registrationform.value);
        let district = this.districtData.filter(a => a.district_id == this.registrationform.value.district_id);
        let ulb = this.ulbData.filter(a => a.ulb_id == this.registrationform.value.ulb_id);
        let slf = this.slfData.filter(a => a.slf_id == this.registrationform.value.slf_id);
        let shg = this.shgGropsReport.filter(a => a.shg_group_id == this.registrationform.value.shg_id);
        let memberdata = this.shgmembersReport.filter(a => a.member_id == this.registrationform.value.member_id);
        this.registrationform.value.profileImg = this.photoPreview;
        this.registrationform.value.district_name = district[0].district_name ?? null;
        this.registrationform.value.ulb_name = ulb[0].ulb_name ?? null;
        this.registrationform.value.slf_name = slf[0].slf_name ?? null;
        this.registrationform.value.shg_group_name = shg[0].shg_group_name ?? null;
        this.registrationform.value.shg_ph_no = memberdata[0].mobile_number ?? null;
        this.registrationform.value.shg_member_name = memberdata[0].member_name ?? null;

        console.log(this.registrationform.value);

        this.showloader = true;
        this.api.submitRegistrationDetails(this.registrationform.value).subscribe((res: any) => {
          this.showloader = false;
          this.submittedregist = false;

          if (res.status === 200) {
            this.registrationform.reset();
            this.photoPreview = null;
            Swal.fire({
              icon: 'success',
              title: 'Registration Successful',
              text: 'Your details have been submitted successfully.',
              confirmButtonText: 'OK'
            });
            this.router.navigate(['/'], { replaceUrl: true })
          } else if (res.status === 409) {
            Swal.fire({
              icon: 'warning',
              title: 'Already Registered',
              text: 'You have already registered. Please login.',
              confirmButtonText: 'Login'
            }).then(() => {
              this.router.navigate(['/'], { replaceUrl: true });
            });
          } else if (res.status === 405) {
            Swal.fire({
              icon: 'error',
              title: 'Invalid OTP',
              text: 'The OTP you entered is incorrect. Please try again.',
              confirmButtonText: 'Retry'
            });
          }
          else {
            Swal.fire({
              icon: 'warning',
              title: 'Submission Failed',
              text: res.message || 'Something went wrong.',
              confirmButtonText: 'Retry'
            });
          }
        },
          (err) => {
            if (err.status === 409) {
              Swal.fire({
                icon: 'warning',
                title: 'Already Registered',
                text: 'You have already registered. Please login.',
                confirmButtonText: 'Login'
              }).then(() => {
                this.router.navigate(['/'], { replaceUrl: true });
              });
            } else if (err.status === 405) {
              Swal.fire({
                icon: 'error',
                title: 'Invalid OTP',
                text: 'The OTP you entered is incorrect. Please try again.',
                confirmButtonText: 'Retry'
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong. Please try again later.'
              });
            }
            this.showloader = false;
            console.error('API error:', err);
          });
      } else {
        alert('Please upload picture')
      }
    }
  };

  newnumaricprevent(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  onImageChange(e: any) {
    console.log(e);
    const reader = new FileReader();
    if (e.target.files && e.target.files.length) {
      const [file] = e.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.photoPreview = reader.result;
        var imgFile = reader.result as string;
        console.log(e.target.files[0].name);
        var bfile_typeEmpl = e.target.files[0].name.split('.');
        console.log("bfile: ", bfile_typeEmpl);
        var imgtype = bfile_typeEmpl[bfile_typeEmpl.length - 1];
        console.log(imgtype);
      };
    }
  }

  verifyOtp() {
    this.submittedregist = true;
    if (this.registrationform.invalid) {
      return;
    } else {
      let memberdata = this.shgmembersReport.filter(a => a.member_id == this.registrationform.value.member_id);
      this.memberNo = memberdata[0].mobile_number ?? null;
      this.registrationform.value.shg_ph_no = memberdata[0].mobile_number ?? null;
      if (this.photoPreview != null) {
        let obj = {
          phonenumber: this.registrationform.value.contact_number
        }
        this.showloader = true;
        console.log(this.registrationform.value);

        this.api.sendRegistarOtp(this.registrationform.value).subscribe((res: any) => {
          if (res.status === 200) {
            // this.otprequestData = res.data;
            this.showloader = false;;
            this.showOtp = true;
            Swal.fire({
              icon: 'success',
              title: 'OTP Sent',
              text: 'Your OTP has been sent successfully.',
              confirmButtonText: 'OK'
            });
          }
        },
          (err) => {
            this.showloader = false;;
            console.error('API error:', err);
          });
      } else {
        alert('Please upload picture')
      }

    }
    // else {
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'Invalid Mobile Number',
    //     text: 'Please enter a valid mobile number.',
    //     confirmButtonText: 'Retry'
    //   });
    // }

  }
}
